import Swiper, { Autoplay }  from 'swiper';

document.addEventListener( 'DOMContentLoaded', () => {
	const sections = document.querySelectorAll('.marquee-section');

	if (!sections.length) return false;

	const init = () => {
		sections.forEach((section) => {
			const slider = section.querySelector('.swiper');
	
			const wrapper = slider.querySelector('.marquee-section .swiper-wrapper');
			const wrapperHtml = wrapper.innerHTML;
	
			const sliderWidth = slider.getBoundingClientRect().width;
			wrapper.style.display = 'inline-flex';
			wrapper.style.width = 'auto';
			let contentWidth = wrapper.scrollWidth;
	
			let iterationLimit = 10;
			while (contentWidth < sliderWidth && iterationLimit > 0) {
				iterationLimit--;
				let currentHtml = wrapper.innerHTML;
				wrapper.innerHTML = currentHtml + wrapperHtml
				contentWidth = wrapper.scrollWidth;
			}
	
			wrapper.style.display = '';
			wrapper.style.width = 'auto';
	
			let speed = slider.getAttribute('data-speed') ? slider.getAttribute('data-speed') : 5000;
			const slideWidth = slider.querySelector('.swiper-slide').getBoundingClientRect().width;
			speed = slideWidth / sliderWidth * speed;

			if (!speed) return false;
	
			let swiper = new Swiper(slider, {
				modules: [Autoplay],
				spaceBetween: 0,
				watchOverflow: true,
				speed: speed,
				autoplay: {
					delay: 0,
				},
				loop: true,
				slidesPerView: 'auto',
				allowTouchMove: false,
				disableOnInteraction: true
			});
		})
	}

	init();

	document.addEventListener('hero-destroy', () => {
		init();
	})
} )
